import { render, staticRenderFns } from "./ZipCardUpload.vue?vue&type=template&id=410edbe9&scoped=true&"
import script from "./ZipCardUpload.vue?vue&type=script&lang=js&"
export * from "./ZipCardUpload.vue?vue&type=script&lang=js&"
import style0 from "./ZipCardUpload.vue?vue&type=style&index=0&id=410edbe9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410edbe9",
  null
  
)

export default component.exports